// extracted by mini-css-extract-plugin
export default {"root":"Header_root__Zj9cy","logo":"Header_logo__fm6Wy","logoBlock":"Header_logoBlock__UXYLN","logoText":"Header_logoText__xgejQ","navMenu":"Header_navMenu__xwSNC"};